export default "__VITE_ASSET__BNr4_x4j__"